import { createSelector } from 'reselect'

const activePairFunction = state => state.matchingPairsCt.activePair
const pairsFunction = state => state.matchingPairsCt.pairs

export default createSelector(
	[activePairFunction, pairsFunction],
	(activePairId, pairs) => {
		const activePair = pairs.find(pair => pair.clientId === activePairId)
		return activePair
	}
)
